module.exports = __webpack_public_path__ + "assets/img/age.e5f6a946.png";